
import Vue from 'vue'
import Component from 'vue-class-component'
import WebpartManagement from '../components/webpart-manage/WebpartManagement.vue'

@Component({
    components: { WebpartManagement },
})
export default class WebpartManageView extends Vue {}
